module.exports = __webpack_public_path__ + "img/Group_84.2634ad5e.svg";